const SIDEBAR_LEFT_CLASS = 'lg:left-64'

module.exports = {
	SIDEBAR_LEFT_CLASS,
	parseDate: function(timestamp, complete = true) {
		if (timestamp === null)
			return null
		const date = new Date(timestamp * 1000)
		let day = date.getDate()
		let month = date.getMonth() + 1
		let year = date.getFullYear()
		let hours = date.getHours()
		let minutes = date.getMinutes()
		let seconds = date.getSeconds()
		if (day < 10)
			day = '0' + day
		if (month < 10)
			month = '0' + month
		if (hours < 10)
			hours = '0' + hours
		if (minutes < 10)
			minutes = '0' + minutes
		if (seconds < 10)
			seconds = '0' + seconds
		if (complete === true)
			return day + "/" + month + "/" + year + " " + hours + ":" + minutes + ":" + seconds
		else
			return day + "/" + month + "/" + year
	},

	parseTimestamp: function(day, month, year, hour = 0, minute = 0, second = 0) {
		return Math.floor(new Date(year, month, day, hour, minute, second).getTime() / 1000)
	},

	getTimestamp: function() {
		return Math.floor(new Date().getTime() / 1000)
	},

	isValidUrl: function(url) {
		try {
			new URL(url)
			return true
		} catch (e) {
			return false
		}
	},

	queryString: function(baseurl, params) {
		const keys = Object.keys(params)
		let url = baseurl + '?'
		let a = false
		for (let i = 0; i < keys.length; i++)
		{
			const key = keys[i]
			if (Array.isArray(params[key]))
			{
				let value = ""
				let b = false
				for (let j = 0; j < params[key].length; j++)
				{
					if (!b)
						b = true
					else
						value += ","
					value += params[key][j]
				}
				if (!a)
					a = true
				else
					url += "&"
				url += key + "=" + value
			}
			else if (params[key])
			{
				if (!a)
					a = true
				else
					url += "&"
				url += key + '=' + params[key]
			}
		}
		if (url.length > 2000)
		{
			console.log("error: query string is longer than 2000 chars, can not send request to url", baseurl)
			return null
		}
		return url
	},

	testEmail: function(email) {
		if (/^[\w!#$%&'*+-/=?^_`{|}~]+(\.[\w!#$%&'*+-/=?^_`{|}~]+)*@((([-\w]+\.)+[a-zA-Z]{2,4})|(([0-9]{1,3}\.){3}[0-9]{1,3}))$/.test(email) === false)
			return false
		else
			return true
	},

	clone: function(obj) {
		return JSON.parse(JSON.stringify(obj))
	},

	// Retourne l'objet de traduction pour la langue demandée, ou null
	getTranslation: function(translations, lang)
	{
		if (!translations)
			return null
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === lang)
				return translations[i]
		}
		return null
	},

	// Retourne la valeur d'un champ traduit ('' si la traduction ou le champ manque)
	getTranslationValue: function(translations, lang, field)
	{
		const translation = this.getTranslation(translations, lang)
		if (!translation || !translation[field])
			return ''
		return translation[field]
	},

	// Liste les langues (parmi langs) où au moins un des champs requis est vide ou absent
	getMissingLangs: function(translations, langs, fields)
	{
		let missing = []
		if (!langs)
			return missing
		for (let i = 0; i < langs.length; i++)
		{
			const translation = this.getTranslation(translations, langs[i])
			let complete = (translation) ? true : false
			if (translation)
			{
				for (let j = 0; j < fields.length; j++)
				{
					if (!translation[fields[j]] || translation[fields[j]].length === 0)
					{
						complete = false
						break
					}
				}
			}
			if (!complete)
				missing.push(langs[i])
		}
		return missing
	},

	// Retourne l'icône de prévisualisation pour un type ('lineal'/'fill') et un thème, ou null
	getIconPreview: function(icons, icon_id, type, theme)
	{
		if (!icons || !icon_id)
			return null
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon_id)
			{
				const variants = icons[i][type]
				if (!variants)
					return null
				for (let j = 0; j < variants.length; j++)
				{
					if (variants[j].theme === theme)
						return variants[j].icon
				}
				return null
			}
		}
		return null
	},

	generateSlug: function(s, opt) {
		s = String(s);
		opt = Object(opt);

		let defaults = {
			'delimiter': '-',
			'limit': undefined,
			'lowercase': true,
			'replacements': {},
			'transliterate': (typeof(XRegExp) === 'undefined') ? true : false
		};

		// Merge options
		for (let k in defaults) {
			if (!opt.hasOwnProperty(k)) {
				opt[k] = defaults[k];
			}
		}

		let char_map = {
			// Latin
			'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE', 'Ç': 'C', 
			'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I', 'Î': 'I', 'Ï': 'I', 
			'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O', 'Ő': 'O', 
			'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U', 'Ű': 'U', 'Ý': 'Y', 'Þ': 'TH', 
			'ß': 'ss', 
			'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 
			'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i', 
			'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ő': 'o', 
			'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u', 'ý': 'y', 'þ': 'th', 
			'ÿ': 'y',

			// NE PAS DÉCOMMENTER
			// SINON ÇA FAIT BUGUER L'IMPORT DU FICHIER DANS REACT
			// MERCI JAVASCRIPT :) :) :) :)

			// // Latin symbols
			// '©': '(c)',

			// // Greek
			// 'Α': 'A', 'Β': 'B', 'Γ': 'G', 'Δ': 'D', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Θ': '8',
			// 'Ι': 'I', 'Κ': 'K', 'Λ': 'L', 'Μ': 'M', 'Ν': 'N', 'Ξ': '3', 'Ο': 'O', 'Π': 'P',
			// 'Ρ': 'R', 'Σ': 'S', 'Τ': 'T', 'Υ': 'Y', 'Φ': 'F', 'Χ': 'X', 'Ψ': 'PS', 'Ω': 'W',
			// 'Ά': 'A', 'Έ': 'E', 'Ί': 'I', 'Ό': 'O', 'Ύ': 'Y', 'Ή': 'H', 'Ώ': 'W', 'Ϊ': 'I',
			// 'Ϋ': 'Y',
			// 'α': 'a', 'β': 'b', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'h', 'θ': '8',
			// 'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': '3', 'ο': 'o', 'π': 'p',
			// 'ρ': 'r', 'σ': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'x', 'ψ': 'ps', 'ω': 'w',
			// 'ά': 'a', 'έ': 'e', 'ί': 'i', 'ό': 'o', 'ύ': 'y', 'ή': 'h', 'ώ': 'w', 'ς': 's',
			// 'ϊ': 'i', 'ΰ': 'y', 'ϋ': 'y', 'ΐ': 'i',

			// // Turkish
			// 'Ş': 'S', 'İ': 'I', 'Ç': 'C', 'Ü': 'U', 'Ö': 'O', 'Ğ': 'G',
			// 'ş': 's', 'ı': 'i', 'ç': 'c', 'ü': 'u', 'ö': 'o', 'ğ': 'g', 

			// // Russian
			// 'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo', 'Ж': 'Zh',
			// 'З': 'Z', 'И': 'I', 'Й': 'J', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N', 'О': 'O',
			// 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C',
			// 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Sh', 'Ъ': '', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'Yu',
			// 'Я': 'Ya',
			// 'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh',
			// 'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
			// 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c',
			// 'ч': 'ch', 'ш': 'sh', 'щ': 'sh', 'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu',
			// 'я': 'ya',

			// // Ukrainian
			// 'Є': 'Ye', 'І': 'I', 'Ї': 'Yi', 'Ґ': 'G',
			// 'є': 'ye', 'і': 'i', 'ї': 'yi', 'ґ': 'g',

			// // Czech
			// 'Č': 'C', 'Ď': 'D', 'Ě': 'E', 'Ň': 'N', 'Ř': 'R', 'Š': 'S', 'Ť': 'T', 'Ů': 'U', 
			// 'Ž': 'Z', 
			// 'č': 'c', 'ď': 'd', 'ě': 'e', 'ň': 'n', 'ř': 'r', 'š': 's', 'ť': 't', 'ů': 'u',
			// 'ž': 'z', 

			// // Polish
			// 'Ą': 'A', 'Ć': 'C', 'Ę': 'e', 'Ł': 'L', 'Ń': 'N', 'Ó': 'o', 'Ś': 'S', 'Ź': 'Z', 
			// 'Ż': 'Z', 
			// 'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z',
			// 'ż': 'z',

			// // Latvian
			// 'Ā': 'A', 'Č': 'C', 'Ē': 'E', 'Ģ': 'G', 'Ī': 'i', 'Ķ': 'k', 'Ļ': 'L', 'Ņ': 'N', 
			// 'Š': 'S', 'Ū': 'u', 'Ž': 'Z', 
			// 'ā': 'a', 'č': 'c', 'ē': 'e', 'ģ': 'g', 'ī': 'i', 'ķ': 'k', 'ļ': 'l', 'ņ': 'n',
			// 'š': 's', 'ū': 'u', 'ž': 'z'
		}

		// Make custom replacements
		for (let k in opt.replacements) {
			s = s.replace(RegExp(k, 'g'), opt.replacements[k]);
		}

		// Transliterate characters to ASCII
		if (opt.transliterate) {
			for (let k in char_map) {
				s = s.replace(RegExp(k, 'g'), char_map[k]);
			}
		}

		// Replace non-alphanumeric characters with our delimiter
		let alnum = RegExp('[^a-z0-9]+', 'ig');
		// var alnum = (typeof(XRegExp) === 'undefined') ? RegExp('[^a-z0-9]+', 'ig') : XRegExp('[^\\p{L}\\p{N}]+', 'ig');
		s = s.replace(alnum, opt.delimiter);

		// Remove duplicate delimiters
		s = s.replace(RegExp('[' + opt.delimiter + ']{2,}', 'g'), opt.delimiter);

		// Truncate slug to max. characters
		s = s.substring(0, opt.limit);

		// Remove delimiter from ends
		s = s.replace(RegExp('(^' + opt.delimiter + '|' + opt.delimiter + '$)', 'g'), '');

		return opt.lowercase ? s.toLowerCase() : s;
	},

	parseCSV: function(file, delimiter = ';')
	{
		const lines = file.replace("\r\n", "\n").split("\n")
		let csv = []
		let c = 0
		const keys = lines[0].split(delimiter)
		let error = false
		let save = null
		for (let i = 1; i < lines.length; i++)
		{
			const line = lines[i]
			if (line.length === 0)
				continue
			let data = line.split(delimiter)
			if (save !== null)
			{
				const last = save.pop()
				data[0] = last + "\n" + data[0]
				data = save.concat(data)
				save = null
			}
			if (data.length !== keys.length)
			{
				if (data.length < keys.length)
				{
					save = data
					continue
				}
				else
				{
					error = i
					break
				}
			}
			csv.push({})
			for (let j = 0; j < keys.length; j++)
			{
				const key = this.generateSlug(keys[j], { delimiter: '_' })
				csv[c][key] = data[j]
			}
			c++
		}
		if (error === false)
			return csv
		else
			return error
	},

	default_error_msg: function(msg, code)
	{
		return 'Erreur: ' + msg + '. Contactez-nous pour résoudre le problème (code erreur: ' + code + ')'
	},

	// Redimensionne une image côté client via Canvas avant upload.
	// Retourne une Promise qui résout en { data, width, height, resized } :
	// data = data URI JPEG, width/height = dimensions finales,
	// resized = true si l'image a été réduite (jamais agrandie).
	// maxWidth / maxHeight : dimensions max (ratio préservé)
	// quality : qualité JPEG entre 0 et 1 (défaut 0.85)
	resizeImageInfo: function(file, maxWidth, maxHeight, quality)
	{
		const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp']
		const MAX_SIZE_MB = 10
		const q = (typeof quality === 'number') ? quality : 0.85

		return new Promise((resolve, reject) => {
			if (!ALLOWED_TYPES.includes(file.type))
			{
				reject('Format non supporté. Utilisez JPG, PNG ou WebP.')
				return ;
			}
			if (file.size > MAX_SIZE_MB * 1024 * 1024)
			{
				reject('Image trop lourde (maximum ' + MAX_SIZE_MB + ' Mo).')
				return ;
			}

			const reader = new FileReader()
			reader.onerror = () => reject('Impossible de lire le fichier.')
			reader.onload = (e) => {
				const img = new Image()
				img.onerror = () => reject('Impossible de décoder l\'image.')
				img.onload = () => {
					let w = img.width
					let h = img.height
					const ratio = Math.min(maxWidth / w, maxHeight / h)
					if (ratio < 1)
					{
						w = Math.round(w * ratio)
						h = Math.round(h * ratio)
					}
					const canvas = document.createElement('canvas')
					canvas.width = w
					canvas.height = h
					const ctx = canvas.getContext('2d')
					ctx.drawImage(img, 0, 0, w, h)
					resolve({ data: canvas.toDataURL('image/jpeg', q), width: w, height: h, resized: (ratio < 1) })
				}
				img.src = e.target.result
			}
			reader.readAsDataURL(file)
		})
	},

	// Variante historique : résout directement la data URI (ConfigWebapp)
	resizeImage: function(file, maxWidth, maxHeight, quality)
	{
		return this.resizeImageInfo(file, maxWidth, maxHeight, quality).then(ret => ret.data)
	}
}
